const OCTxBean = {
  login: "/api/OCTxBean/login",
  logout: "/api/OCTxBean/logout",
  authCodeHandler: "/api/OCTxBean/authCodeHandler",
  checkLoginOC: "/api/OCTxBean/checkLoginOC",
  getOCMember: "/api/OCTxBean/getOCMember"
};
export default OCTxBean;
